<template>
    <div>
        <!-- <div class="inplay-details-page-section" v-if="sport_tab == 'inplay'"> -->

        <div class="inplay-details-page-section" v-if="$route.name == 'Inplay'">

            <section class="casino-game-type-name-sec">
                <div class="home-casino-game-wrapper">
                    <div class="home-casino-game-logo"
                        v-for="(game, index) in sectionWiseGamesList[0].gamesList"
                        :key="index"> 
                        <a href="#" @click.prevent="loadGame(game)" :aria-label="game.game_name">
                            <img :src="game?.image" :alt="game.game_name" loading="lazy"  />
                        </a> 
                        <!-- <button v-if="index + 1 === 10 && sectionWiseGamesList[0].seeAll==false" class="load-more-img" type="button" @click="sectionWiseGamesList[0].seeAll=true">
                            {{ $t('more','More')}}
                        </button>
                        <button v-if="index + 1 === 10 && sectionWiseGamesList[0].seeAll==true" class="load-more-img view-less-btn" type="button" @click="sectionWiseGamesList[0].seeAll=false">
                            {{ $t('less','Less')}}
                        </button> -->
                    </div>
                </div>
            </section>
            <section class="static-home-games">
                <div class="game-card2 cursor-pointer" v-for="(game, gIndex) in staticGames" :key="gIndex" @click="loadGame(game)" 
                    :class="[className, { 'static-cls': game?.catSlug === 'static-games' }]">
                    <a href="Javascript:void(0);">
                        <div class="casino-list-item-img">
                            <img loading="lazy" :src="game?.image || game?.imgSrc" :alt="'game-img-' + (gIndex + 1)" @error="setDefaultImg($event)">
                        </div>
                    </a>
                </div>
            </section>
            <section class="next-events-sec">
                <div class="sports-list">
                    <div class="accordion" id="accordionExample">
                        <!-- Commented this because not need to show here -->
                        <!-- <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                        <button class="accordion-button sports-list-head" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        <span>Next Horse Race</span>
                                        </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <div class="race-details-section">
                                                <Race :type="'HORSE_RACE'" />
                                            </div>
                                        </div>
                                    </div>
                                </div> -->

                                 <!-- <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingTwo">
                                        <button class="accordion-button collapsed sports-list-head" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            <span> NEXT GREYHOUND RACE </span>
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" class="accordion-collapse collapse show" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <div class="inplay-cricket">
                                                <div class="race-details-section">
                                                    <Race :type="'GREY_HOUND_RACING'" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->

                        <!-- this code is commented because not need here  -->
                         <!-- <div class="accordion-item" v-if="recommended_matches && recommended_matches.length > 0">
                            <h2 class="accordion-header" id="headingThree">
                                <button class="accordion-button sports-list-head collapsed" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false"
                                    aria-controls="collapseThree">
                                    <span>{{ $t('featured-events','FEATURED EVENTS')}}</span>
                                </button>
                            </h2>
                            <div id="collapseThree" class="accordion-collapse collapse show" aria-labelledby="headingThree"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <div class="feature-events-sec">
                                        <table class="table">
                                            <tbody>

                                                <tr v-for="(match, r_index) in recommended_matches" :key="r_index">
                                                    <td>
                                                        <div class="league-sec">
                                                            <a @click="goto_eventDetail(match.event_id)">
                                                                <div class="league-name">
                                                                    <div class="event-name-left">
                                                                        <span>{{ $dateTime.convertDate(match.event_date, 'DD/MM/YYYY  hh:mm:ss A') }}</span>
                                                                        <br>
                                                                        <span> <strong>{{ match.event_name}}</strong></span>
                                                                        <br>
                                                                        <span class="minus">0</span>
                                                                    </div>
                                                                    <div class="event-name-right">
                                                                        <ul class="inply-crk">
                                                                            <li class="dots" v-if="match.inplay == true">
                                                                                <i class="fa-solid fa-circle"></i>
                                                                            </li>
                                                                            <li class="bm" v-if="match.has_bookmaker == 1">
                                                                                <span>BM</span>
                                                                            </li>
                                                                            <li class="bm" v-if="match.has_fancy == 1">
                                                                                <span>F</span>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>  -->

                        <template v-for="(sport, s_index) in {...inplay_matches, ...secondaryInplayMatches}" :key="s_index">

                            <div class="accordion-item" v-if="sport.length">
                                <h2 class="accordion-header" :id="'headingfive' + s_index?.replace(/\s+/g, '')">
                                    <button class="accordion-button sports-list-head" type="button"
                                        data-bs-toggle="collapse" :data-bs-target="'#collapsefive' + s_index?.replace(/\s+/g, '')"
                                        aria-expanded="true" :aria-controls="'collapsefive' + s_index?.replace(/\s+/g, '')">
                                        <span>{{$t(s_index.toLowerCase(),s_index)}}</span>
                                    </button>
                                </h2>
                                <div :id="'collapsefive' + s_index?.replace(/\s+/g, '')" class="accordion-collapse collapse show"
                                    :aria-labelledby="'headingfive' + s_index?.replace(/\s+/g, '')">
                                    <div class="accordion-body">
                                        <div class="feature-events-sec">
                                            <table class="table">
                                                <tbody>
                                                    <tr v-for="(match, m_index) in sport" :key="m_index">
                                                        <td>
                                                            <SportsItem :match="match"   ></SportsItem>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>


                    </div>
                </div>
            </section>

        </div>
        <div class="inplay-details-page-section" v-else-if="$route.name == 'Featured'">
            <section class="next-events-sec">
                <div class="sports-list">
                    <div class="accordion" id="accordionExample">
                         <div class="accordion-item">
                            <!-- <h2 class="accordion-header" id="headingThree">
                                <button class="accordion-button sports-list-head collapsed" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false"
                                    aria-controls="collapseThree">
                                    <span>FEATURED EVENTS</span>
                                </button>
                            </h2> -->
                            <div id="collapseThree" class="accordion-collapse collapse show" aria-labelledby="headingThree"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <div class="feature-events-sec">
                                        <table class="table">
                                            <tbody>

                                                <tr v-for="(match, r_index) in recommended_matches" :key="r_index">
                                                    <td>
                                                        <div class="league-sec">
                                                            <a @click="goto_eventDetail(match.event_id)">
                                                                <div class="league-name">
                                                                    <div class="event-name-left">
                                                                        <span>{{ $dateTime.convertDate(match.event_date, 'DD/MM/YYYY  hh:mm:ss A') }}</span>
                                                                        <br>
                                                                        <span> <strong>{{ match.event_name
                                                                        }}</strong></span>
                                                                        <br>
                                                                        <span class="minus">0</span>
                                                                    </div>
                                                                    <div class="event-name-right">
                                                                        <ul class="inply-crk">
                                                                            <li class="dots" v-if="match.inplay == true">
                                                                                <i class="fa-solid fa-circle"></i>
                                                                            </li>
                                                                            <li class="bm" v-if="match.has_bookmaker == 1">
                                                                                <span>BM</span>
                                                                            </li>
                                                                            <li class="bm" v-if="match.has_fancy == 1">
                                                                                <span>F</span>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
            </section> 
        </div> 
        
        <div v-else>
            <div class="feature-events-sec">
                <table class="table">
                    <tbody>
                        <template v-if="matches_list?.length">
                            <tr v-for="(match, m_index) in matches_list" :key="m_index">
                                <td>
                                    <SportsItem :match="match"  ></SportsItem>
                                </td>
                            </tr>
                        </template>
                        <template v-else>
                            <NoDataFound :isSearch="false"/>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import socketService from "/src/socket/sport-socket-service.js";
import * as varConstants from '@/shared/constants/var-constants';
import loadCasinoGame from "@/shared/services/casinoGamesHandler";
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
export default {
    name: 'Inplay',
    components: {
        Race: defineAsyncComponent(() => import("@/shared/components/race/Race.vue")),
        SportsItem: defineAsyncComponent(() => import("../components/SportsItem.vue")),
        NoDataFound: defineAsyncComponent(() => import('@/shared/components/no-data/NoDataFound.vue'))
    },
    data() {
        return {
            // start new code below for socket by 11xplay
            inplayMarketOdds: {},
            socketEmitterList: [],
            // end new code
            betType: null,
            betData: {
                odds: null,
                quickStakes: {
                }
            },
            sport_tab: 'inplay',
            sport_id: null,
            matches_list: [],
            inplay_matches: {},
            recommended_matches: [],


            sectionsList: null,
            recommendedGameList: null,
            sectionWiseGamesList: [
                {
                    slugName: "home-casino",
                    // slugName: "top-games",
                    gamesList: null,
                    seeAll: false,
                    defaultGames: 11,
                },
                // {
                //     slugName: 'top-games',
                //     gamesList: null,
                //     seeAll: false,
                //     defaultGames: 5,
                // },
                // {
                //     slugName: 'royal-live-games',
                //     gamesList: null,
                //     seeAll: false,
                //     defaultGames: 5,
                // },
                // {
                //     slugName: 'royal-virtual',
                //     gamesList: null,
                //     seeAll: false,
                //     defaultGames: 5,
                // },
                // {
                //     slugName: 'live-casino',
                //     gamesList: null,
                //     seeAll: false,
                //     defaultGames: 5,
                // },
                // {
                //     slugName: 'game-shows',
                //     gamesList: null,
                //     seeAll: false,
                //     defaultGames: 5,
                // },
                // {
                //     slugName: 'world-casino',
                //     gamesList: null,
                //     seeAll: false,
                //     defaultGames: 5,
                // }
            ],
            staticGames: [
                {
                    game_name: 'Aviator',
                    slug: 'aviator',
                    catSlug: 'static-games',
                    imgSrc: require('@/assets/images/aviator.gif')
                },
                {
                    game_name: 'Mines',
                    slug: 'mines',
                    catSlug: 'static-games',
                    imgSrc: require('@/assets/images/mines.gif')
                },
                {
                    game_name: 'Fun Games',
                    slug: 'fun-games',
                    catSlug: 'static-games',
                    imgSrc: require('@/assets/images/fungames.gif')
                },
                {
                    game_name: 'Color Pridiction',
                    slug: 'colour-game',
                    catSlug: 'static-games',
                    imgSrc: require('@/assets/images/color-pridiction.gif')
                }
            ],
            choosedUserJourney: { link: null, title: null },
            showUserJourneyVideo: false,
            secondaryInplayMatches:{}
        }
    },
    computed: {
         ...mapGetters(['eventManage','favouriteGames', 'gamesData']),
		},
    watch: {
        "$store.state.commonStore.sport_tab": function () {
            this.sport_tab = this.$store.state.commonStore.sport_tab
            this.sport_id = this.$store.state.commonStore.sport_tab
            if (this.sport_tab != 'inplay')
                this.get_matches()
        },
        '$route.params.id': function () {
            if(this.$route.params.id == 4) {
                this.get_matches(4);
            }
        }
    },
    created() { 
        this.$store.commit('set_sport_tab', 'inplay')
        this.getCasinoGamesServiceCall();
    },
    mounted() {
        let routeName = this.$route.name
        if (routeName == "Inplay") {
            this.get_inplay_matches();
        } else {
            let newSportId = this.$route.params.id;
            this.matches_list = this.get_matches(newSportId);
        }
    },
    methods: {
        checkLayBack(event, type) {
            this.betType = false
            this.betData.odds = 2.00;
            this.betData.quickStakes = 1000;
            this.$nextTick().then(() => {
                const betSlipElement = document.querySelector('.betslip');
                if (betSlipElement) {
                    event.target.closest('.bet-slip-area').appendChild(betSlipElement);
                }
            });
            this.betType = type
            setTimeout(() => {
                this.betType = null
            },
                10000
            );

        },
        checkEventManageforSports(sportId) {
            if(this.$auth.status) {
                let sportEventManage = this.eventManage?.find(item => item.type == 'sports');
                if(sportEventManage) {
                    let sportIds = sportEventManage.type_id.split(',');
                    return !sportIds.includes(sportId.toString());
                }
            }
            return true;    
        },
        checkInEventMangeForGame(typeId, gameCode, LockedProvider, LockedProviderGames)
        {
            return (LockedProvider.length || LockedProviderGames.length) ? !(LockedProviderGames.includes(gameCode.toString())) && !(LockedProvider.includes(typeId.toString())) :true;
        },
        checkForLockedMatches(matchId, league_id, lockedMatchIds, lockedLeagueIds) {
            return this.$auth.status && (lockedMatchIds.length || lockedLeagueIds.length) ? !lockedMatchIds.includes(matchId.toString()) && !lockedLeagueIds.includes(league_id.toString()) : true
        },
        get_inplay_matches() {
            // debugger;
            this.loading = true;
            this.$apiCall('get', 'INPLAY_MATCHES_LIST', null, 'sports').then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        var inplay_match_list = response.data.data.inplay
                        this.recommended_matches = response.data.data.recommended
                        var cricket = []
                        var soccer = []
                        var tennis = []
                        this.inplayMarketOdds = {};
                        let lockedMatchIds = [];
                        let lockedLeagueIds = [];
                        if(this.$auth.status && this.eventManage) {
                            lockedMatchIds = this.eventManage.find(item => item.type == 'match');
                            lockedLeagueIds = this.eventManage.find(item => item.type == 'league');

                            lockedMatchIds = lockedMatchIds && lockedMatchIds.type_id !== null ? lockedMatchIds.type_id.split(',') : [];
                            lockedLeagueIds = lockedLeagueIds && lockedLeagueIds.type_id !== null ? lockedLeagueIds.type_id.split(',') : []
                        }
                        for (var i = 0; i < inplay_match_list.length; i++) {
                            if(this.checkEventManageforSports(inplay_match_list[i].sport_id) && this.checkForLockedMatches(inplay_match_list[i].matchId, inplay_match_list[i].league_id, lockedMatchIds, lockedLeagueIds)) {
								inplay_match_list[i]['favourite']=this.favouriteGames?.includes(parseInt(inplay_match_list[i].event_id))
                                if (inplay_match_list[i].sport_id == 4) {
                                    cricket.push(inplay_match_list[i])
                                }
                                else if (inplay_match_list[i].sport_id == 1) {
                                    soccer.push(inplay_match_list[i])
                                } else if (inplay_match_list[i].sport_id == 2) {
                                    tennis.push(inplay_match_list[i])
                                } else {
                                        if(!this.secondaryInplayMatches[inplay_match_list[i].sport_name]){
                                            this.secondaryInplayMatches[inplay_match_list[i].sport_name] = [];
                                        };
                                        this.secondaryInplayMatches[inplay_match_list[i].sport_name].push(inplay_match_list[i])
                                }
                                this.inplayMarketOdds[inplay_match_list[i].market_id] = inplay_match_list[i].runners ?? [];
                            }
                        }
                        this.inplay_matches['Cricket'] = cricket
                        this.inplay_matches['Football'] = soccer
                        this.inplay_matches['Tennis'] = tennis
                        localStorage.setItem("Matches", JSON.stringify(this.inplay_matches))
                        // new code below for socket by 11xplay
                        if(Object.entries(this.inplayMarketOdds).length) {
							socketService.emit("sub", 'inplay.markets');
							socketService.on("inplay.markets", (bMarketOdds) => {
								for(let incomingMarket in bMarketOdds){
									let marketOdd = this.inplayMarketOdds[incomingMarket];
									let newMarketOdds = bMarketOdds[incomingMarket];
									if(!marketOdd) return;
									if(newMarketOdds?.runners){
										for(let runner of newMarketOdds.runners) {
										let mRunner = marketOdd.find(r=> r.sid == runner.sid);
										if(!mRunner) continue;
										// back available 
										if(runner.ex.b) {
											mRunner.ex.b = runner.ex.b;
										}
										// lay available
										if(runner.ex.l) {
											mRunner.ex.l = runner.ex.l;
										}
									}
									}
									
								}
							})
						}
                        // end new code

                        this.recommendedSportsList =  response.data.data.recommended;
						for(var j=0;j<this.recommendedSportsList.length;j++){
							if(this.favouriteGames?.includes(parseInt(this.recommendedSportsList[j].event_id))){
									this.recommendedSportsList[j]['favourite']=true
								}else{
									this.recommendedSportsList[j]['favourite']=false
							}  
						}
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    console.log("Error : ", error);
                    this.showErrorModalFunc(error?.data?.message);
                }
            });
        },

        get_matches(sportId) {
            this.$store.dispatch('setGlobalLoader', true);
            let sendId = sportId ? sportId : this.sport_id
            this.$apiCall('get', 'MATCHES_BY_SPORT_ID', null, 'sports', { sport_id: sendId }).then(response => {
                this.$store.dispatch('setGlobalLoader', false);
                if (response) {
                    if (response.status == 200) {
                        this.matches_list = response.data.data;

                        let lockedMatchIds = [];
                        let lockedLeagueIds = [];
                        if(this.$auth.status && this.eventManage) {
                            lockedMatchIds = this.eventManage.find(item => item.type == 'match');
                            lockedLeagueIds = this.eventManage.find(item => item.type == 'league');

                            lockedMatchIds = lockedMatchIds && lockedMatchIds.type_id !== null ? lockedMatchIds.type_id.split(',') : [];
                            lockedLeagueIds = lockedLeagueIds && lockedLeagueIds.type_id !== null ? lockedLeagueIds.type_id.split(',') : []
                        }

                        for (var i = this.matches_list.length - 1; i >= 0; i--) {
                            if(this.checkForLockedMatches(this.matches_list[i].matchId, this.matches_list[i].league_id, lockedMatchIds, lockedLeagueIds)) {
                               if (this.favouriteGames?.includes(parseInt(this.matches_list[i].event_id))) {
                                    this.matches_list[i]['favourite'] = true
                                } else {
                                    this.matches_list[i]['favourite'] = false
                                }
                            } else {
                                this.matches_list.splice(i, 1)
                            }
                        }
                    }
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    console.log("Error : ", error);
                    // this.showErrorModalFunc(error.data.message);
                }
            });
        },
        goto_eventDetail(id) {
            this.$router.push('sports-event-detail/' + id)
        },
        chooseUserJourney(userJourneLink, title) {
            if (userJourneLink) {
                userJourneLink = this.$siteSettings?.data.aws_url + this.$siteSettings?.data.storage_path.user_journey_path + userJourneLink;
            }
            this.choosedUserJourney = { link: userJourneLink, title: title };
            //this.$bvModal.show('user_journey');
            this.showUserJourneyVideo = true;
            this.$refs.show_user_journey_video.click();
        },
        getCasinoGamesServiceCall() {
            let casinoData = this.gamesData
            this.sectionsList = casinoData?.sections;
            this.recommendedGameList = casinoData?.recommended_games;
            this.setSectionList();
        },

        setSectionList() {
            try {
                for (let i = 0; i < this.sectionsList?.length; i++) {
                    let gamesList = [];
                    if (this.sectionsList[i].menus) {
                        for (let j = 0; j < this.sectionsList[i]?.menus?.length; j++) {
                            gamesList = gamesList.concat(this.sectionsList[i]?.menus[j]?.games);
                        }
                    } else {
                        gamesList = this.sectionsList[i]?.games;
                    }

                    // if (this.$auth.status && this.favouriteGames && this.favouriteGames.length != 0) {

                    //     for (var k = 0; k < gamesList.length; k++) {
                    //         if (this.favouriteGames.includes(gamesList[k].id)) {
                    //             gamesList[k]['favourite'] = true
                    //         } else {
                    //             gamesList[k]['favourite'] = false
                    //         }
                    //     }
                    // }
                    /* ******************* */
                    // this.providers = this.sectionWiseGamesList[0].gamesList
                    switch (this.sectionsList[i].slug) {
                        case 'home-casino':
                            this.sectionWiseGamesList[0].gamesList = gamesList;
                            break;
                    }
                }

                for (var k = 0; k < this.recommendedGameList?.length; k++) {
                    if (this.favouriteGames?.includes(this.recommendedGameList[k].id)) {
                        this.recommendedGameList[k]['favourite'] = true
                    } else {
                        this.recommendedGameList[k]['favourite'] = false
                    }
                }
            } catch (error) {
                console.log("Error in setSection list : ", error);
            }
        },
        getImageBaseUrl() {
            return this.$store?.getters?.$siteSettings?.data?.aws_url ? this.$store?.getters?.$siteSettings?.data?.aws_url : process.env.VUE_APP_AMAZON_AWS;
        },
        showErrorModalFunc(message) {
            this.$errorToast(message);
        },
        showSuccessModalFunc(message) {
            this.$successToast(message);
        },
        loadGame(game) {
            if(game?.catSlug && game?.catSlug == 'static-games'){
                this.$router.push({name: 'Games', params: {type: 'casino'}, query: {menuName: game.slug}});
            }
            else if(!this.$auth.status) {
                this.$helper.showLogin()
                return;
            }
            loadCasinoGame.loadGame(game, this.$auth.user);
        },
    },
    beforeUnmount() {
        socketService.off('App\\\\Events\\\\MarketBroadcastData');
        socketService.emit("leave", this.socketEmitterList);
    }

}
</script>

<style scoped>
.rate-text {
    font-size: 11px;
    font-weight: 600;
}

</style>